import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["cta", "tooltip", "applyButton", "removeButton", "autoFocus", "validCode", "showPromoField", "appliedText", "errorMessage", "text", "containerClassName", "onSubmit", "promoCodeCheckoutMessage"],
  _excluded2 = ["text", "onClick"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useRef, useState } from 'react';
import Colors from "../../Color/Colors";
import Utility from "../../Utility/Utility";
import { Button } from "../../Button/Button/Button";
import { Text } from "../../Text/Text/Text";
import { Popup } from "../../Popup/Popup/Popup";
import { IconButton } from "../../Button/IconButton/IconButton";
import { ValidatedInput } from "../ValidatedInput/ValidatedInput";
import { Icon } from "../../Icon/Icon/Icon";
import styles from "./PromoCodeInput.module.scss";
import { SvgPromoCheck } from "../../Icon/Icon/icons/components/PromoCheck";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PromoCodeInput = function PromoCodeInput(_ref) {
  var cta = _ref.cta,
    tooltip = _ref.tooltip,
    applyButton = _ref.applyButton,
    removeButton = _ref.removeButton,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$validCode = _ref.validCode,
    validCode = _ref$validCode === void 0 ? false : _ref$validCode,
    _ref$showPromoField = _ref.showPromoField,
    showPromoField = _ref$showPromoField === void 0 ? false : _ref$showPromoField,
    appliedText = _ref.appliedText,
    errorMessage = _ref.errorMessage,
    _ref$text = _ref.text,
    initText = _ref$text === void 0 ? '' : _ref$text,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
    _ref$onSubmit = _ref.onSubmit,
    onSubmitInit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    promoCodeCheckoutMessage = _ref.promoCodeCheckoutMessage,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // All letters and numbers
  var promoCodeRegex = /^[a-z\d\-_\s]+$/i;
  var dirty = useRef(false);
  var _useState = useState(initText),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var onSubmit = function onSubmit(newText) {
    dirty.current = false;
    onSubmitInit(newText);
  };
  var onChangeText = function onChangeText(newText) {
    dirty.current = true;
    setText(newText);
  };
  var renderCTA = function renderCTA() {
    var _ref2 = cta || {},
      text = _ref2.text,
      onClick = _ref2.onClick,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("div", {
      className: styles.ctaWrapper,
      children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        type: "link",
        className: styles.ctaLink,
        onClick: onClick
      }, otherProps), {}, {
        size: "large",
        children: text
      }))
    });
  };
  var renderRemoveBtn = function renderRemoveBtn() {
    var onClick = removeButton.onClick;
    var className = tooltip !== null && tooltip !== void 0 && tooltip.text ? undefined : styles.noTooltip;
    return /*#__PURE__*/_jsx(Button, {
      type: "link",
      size: "small",
      onClick: onClick,
      className: className,
      children: removeButton.text
    });
  };
  var renderPromoCodeInput = function renderPromoCodeInput() {
    return /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
      errorMessage: dirty.current ? '' : errorMessage,
      regex: promoCodeRegex,
      onChangeText: onChangeText,
      onSubmit: onSubmit,
      text: text,
      buttonText: applyButton.text,
      autoFocus: autoFocus
    }, otherProps));
  };
  var popupComponent = useRef(null);
  var togglePopup = function togglePopup() {
    var _popupComponent$curre;
    popupComponent === null || popupComponent === void 0 ? void 0 : (_popupComponent$curre = popupComponent.current) === null || _popupComponent$curre === void 0 ? void 0 : _popupComponent$curre.togglePopup();
  };
  var renderTooltip = function renderTooltip() {
    var _ref3 = tooltip || {},
      text = _ref3.text,
      accessibilityLabel = _ref3.accessibilityLabel;
    return tooltip && text && /*#__PURE__*/_jsx(Popup, {
      ref: popupComponent,
      handle: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": accessibilityLabel,
        className: styles.tooltipIcon,
        icon: "info",
        fill: Colors.colorWW740,
        size: "20px",
        onClick: togglePopup
      }),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.popupContent,
        children: /*#__PURE__*/_jsx(Text, {
          typog: "bodycopy",
          children: Utility.dangerousHTML(text)
        })
      })
    });
  };
  var renderPromoCodeApplied = function renderPromoCodeApplied() {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.promoCodeContainer,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.promoPill,
        children: [/*#__PURE__*/_jsx(SvgPromoCheck, {
          className: styles.promoCheck
        }), /*#__PURE__*/_jsx(Text, {
          className: styles.promoApplied,
          typog: "bodycopySmall",
          textElement: "span",
          childrenInline: true,
          children: appliedText
        })]
      }), renderRemoveBtn(), renderTooltip()]
    });
  };
  var renderPromoCodeMessage = function renderPromoCodeMessage() {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.promoCodeMessage,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.promoCodeIcon,
        children: /*#__PURE__*/_jsx(Icon, {
          type: "promo-check",
          fill: Colors.colorWW300,
          height: "13px",
          width: "13px"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typog: "bodycopy",
        children: promoCodeCheckoutMessage
      })]
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: containerClassName,
    children: [!validCode && !promoCodeCheckoutMessage && renderCTA(), !validCode && showPromoField && !promoCodeCheckoutMessage && renderPromoCodeInput(), promoCodeCheckoutMessage && renderPromoCodeMessage(), validCode && !promoCodeCheckoutMessage && renderPromoCodeApplied()]
  });
};